import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow_back",
  "use": "icon-arrow_back-usage",
  "viewBox": "0 0 49 48",
  "content": "<symbol viewBox=\"0 0 49 48\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-arrow_back\"><path d=\"M24.5 39.2307L9.2693 24L24.5 8.7693L26.0999 10.3693L13.5845 22.8654H39.7307V25.1346H13.5845L26.0999 37.6307L24.5 39.2307Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol